import { render, staticRenderFns } from "./qtySnapshotRecord.vue?vue&type=template&id=4b1331bd&scoped=true"
import script from "./qtySnapshotRecord.vue?vue&type=script&lang=js"
export * from "./qtySnapshotRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1331bd",
  null
  
)

export default component.exports